import { render, staticRenderFns } from "./therapy-for-book-appointment.html?vue&type=template&id=cd89aade&scoped=true&external"
import script from "./therapy-for-book-appointment.js?vue&type=script&lang=js&external"
export * from "./therapy-for-book-appointment.js?vue&type=script&lang=js&external"
import style0 from "./therapy-for-book-appointment.scss?vue&type=style&index=0&id=cd89aade&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd89aade",
  null
  
)

export default component.exports